import { EachCurrentCollision } from "../EachCurrentCollision";
import { ModelPath } from "../ModelPath";

import { Set2 } from "./Set2";

export class ModelPathSet extends Set2<ModelPath> {
    private readonly eachCurrentCollision: EachCurrentCollision;

    public constructor(eachCurrentCollision: EachCurrentCollision = EachCurrentCollision.AreSame) {
        super();
        this.eachCurrentCollision = eachCurrentCollision;
    }

    public static *unique(paths: Iterable<ModelPath>): Iterable<ModelPath> {
        const set = new ModelPathSet();
        for (const path of paths) {
            if (set.add(path)) {
                yield path;
            }
        }
    }

    protected areItemsEqual(left: ModelPath, right: ModelPath): boolean {
        return left.isEquals(right, this.eachCurrentCollision);
    }

    protected getItemHash(key: ModelPath): number {
        return key.getHash(this.eachCurrentCollision);
    }
}
